class Activity {
  constructor(id = null, description = "", multiplier = 1.0) {
    this.id = id;
    this.description = description;
    this.multiplier = multiplier;
  }
}

export default Activity;
